import { useMutation } from "@tanstack/react-query"

import { toggleUserSMSStatus } from "./api"
import { queryClient } from "../../queryClient"
import { QueryKey } from "../../types/queries"

export const useToggleSMSMutation = () => {
  return useMutation({
    mutationFn: toggleUserSMSStatus,
    onMutate: async ({ userId, status }) => {
      await queryClient.cancelQueries({
        queryKey: [QueryKey.USER_SMS_STATUS],
      })

      const previousSMSStatus = queryClient.getQueryData<boolean>([
        QueryKey.USER_SMS_STATUS,
      ])

      queryClient.setQueryData([QueryKey.USER_SMS_STATUS, userId], () => {
        return status
      })

      return { previousSMSStatus }
    },
    onError: (_error, variables, context) => {
      queryClient.setQueryData(
        [QueryKey.USER_SMS_STATUS, variables.userId],
        context?.previousSMSStatus
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.USER_SMS_STATUS] })
    },
  })
}
